import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {HomeSectionLink as HomeSectionLinkComponent} from 'components/HomeSection';
import {Tag as TagComponent} from '@guestapp/old-ui-kit';

export const HomeSectionLink = styled(HomeSectionLinkComponent)`
  position: relative;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.6) 100%);
  color: #fff;
  overflow: hidden;

  .HomeSectionLink__icon {
    --icon-color: #fff;
  }
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -3;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
`;

export const BackgroundImageOverlay = styled.div`
  opacity: 0.7;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  background-color: ${({theme}) => theme.colors.branding.primary};
`;

export const ContentPicture = styled.picture`
  display: contents;
`;

export const ContentImage = styled.img`
  z-index: -1;
  position: relative;
  float: right;

  margin-block: -24px;
  border-radius: 12px;
  object-fit: cover;
  object-position: top;

  shape-outside: border-box;
  shape-margin: 12px;
  max-height: 120px;

  @media (max-width: ${DEVICE.laptop}) {
    margin-block: unset;
    margin-bottom: -40px;
    height: 71px;
  }
`;

export const Tags = styled.div`
  margin-top: 4px;
  & > * {
    margin-right: 8px;
    margin-top: 8px;
  }
`;

export const AdditionalText = styled.div`
  margin-top: 4px;
  color: #ffd166;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const Title = styled.div`
  display: flex;
  gap: 8px;
  font-size: 18px;
  margin-bottom: 4px;
  align-items: start;
`;

export const Tag = styled(TagComponent)`
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
`;

export const TitleTag = styled(TagComponent)`
  color: #923c01;
  background: #ffd166;
`;
